// Calculator-URL sanitizer (PenPal #6/#11, CWE-601).
//
// AWS Pricing Calculator URLs flow from untrusted sources (URL query params,
// partner-supplied pricingCalculatorLinks[], API responses) into browser
// navigation sinks (window.open, Cloudscape <Link href>). Without a scheme/host
// check, a `javascript:`, `data:`, or off-site `https://` value reaches the sink
// and turns a trusted Chronos CTA into an open-redirect / XSS-flavored phishing
// primitive. Validate every value at the sink before binding it.
//
// Allow only https on the known AWS calculator hosts. Anything else returns null;
// callers must render a disabled control / error instead of navigating.

const ALLOWED_HOSTS = new Set([
  'calculator.aws',
  'aws.amazon.com',
  'pricing.calculator.aws.eu',
]);

export function sanitizeCalculatorUrl(raw) {
  if (typeof raw !== 'string' || raw.length > 2048) return null;
  let parsed;
  try {
    parsed = new URL(raw);
  } catch {
    return null; // not an absolute URL (blocks relative/garbage/`javascript:` w/o host)
  }
  if (parsed.protocol !== 'https:') return null; // blocks javascript:, data:, http:
  const host = parsed.hostname.toLowerCase();
  const ok = [...ALLOWED_HOSTS].some((h) => host === h || host.endsWith('.' + h));
  return ok ? parsed.toString() : null;
}
